<template>
  <div class="nav-header-box">
    <div class="nav-header">
      <div class="nav-left">
        <a @click="backHome"><img :src="$root.tenantInfo.logoUrl" v-if="$root.tenantInfo.logoUrl" :alt="$root.tenantInfo.name" class="logo"></a>
        <span class="s-name">{{ $root.tenantInfo.name }}</span>
      </div>
      <div class="main-nav" v-show="!(menus.length == 1 && $root.userInfo.roleCodes == 'specialist')">
        <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect" ref="elMenu" menu-trigger="hover">
          <template v-for="item in menus">
            <el-submenu :index="item.path" popper-class="sub-item" v-if="item.children && item.children.length > 0 && !item.isHide" :key="item.id">
              <template slot="title">
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item :index="sItem.path" v-for="sItem in item.children" :key="sItem.menuID">
                <span slot="title">{{ sItem.name }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item :index="item.path" v-else :key="item.path" :class="{ 'is-active': item.path.indexOf(parentActiveIndex) >= 0 }">
              <span>{{ item.name }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
      <div class="nav-right">
        <template v-if="msItem">
          <el-link @click="handleSelect(msItem.path)" class="link">{{ msItem.name }}</el-link>
          <span class="v-line"></span>
        </template>
        <div class="inline-block" @click.stop="wxDialogShow">
          <el-popover placement="bottom" trigger="hover" popper-class="popper-code">
            <div class="text-center">
              <img src="/static/img/wx_code.jpg" alt="" style="height:100px">
            </div>
            <span class="iconfont icon wx-icon" slot="reference">&#xe63f;</span>
          </el-popover>
        </div>
        <span class="v-line"></span>
        <div class="inline-block mr-10">
          <img src="/static/img/defalut_head.jpg" class="avatar" alt="" v-if="!$root.userInfo.userAvatarUrl" @click="modifyInfo('show')">
          <img :src="$root.userInfo.userAvatarUrl" class="avatar" alt="" v-if="$root.userInfo.userAvatarUrl" @click="modifyInfo('show')">
        </div>
        <span class="font-15">欢迎您，</span>
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <span class="font-15 name">{{ userInfo.realName }}</span><i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="modifyInfo('show')">个人设置</el-dropdown-item>
            <el-dropdown-item @click.native="logOut">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-dialog title="个人信息设置" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false">
      <div style="padding:0px;min-height:300px;margin-top: -15px;">
        <el-tabs v-model="modifyType" @tab-click="handleModifyType">
          <el-tab-pane label="修改基础信息" name="1"></el-tab-pane>
          <el-tab-pane label="修改密码" name="2"></el-tab-pane>
        </el-tabs>
        <el-form class="mt-20" :model="form" :rules="rules" ref="userForm" label-width="90px" v-show="modifyType == '1'">
          <el-form-item label="登录账号：">
            <span>{{ $root.userInfo.loginName }}</span>
          </el-form-item>
          <el-form-item label="姓名：" prop="realName">
            <el-input v-model="form.realName" placeholder="用户姓名"></el-input>
          </el-form-item>
          <el-form-item label="昵称：" prop="name">
            <el-input v-model="form.name" placeholder="用户昵称"></el-input>
          </el-form-item>
          <el-form-item label="性别：" prop="sex">
            <el-radio-group v-model="form.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="民族：" prop="nation">
            <el-select v-model="form.nation" filterable placeholder="请选择">
              <el-option v-for="item in nationList" :key="item.id" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="年级：" prop="classLevel" v-if="form.tenantType != 1">
            <el-select v-model="form.classLevel" placeholder="请选择" :clearable="true">
              <el-option label="职高(一)" :value="71"></el-option>
              <el-option label="职高(二)" :value="72"></el-option>
              <el-option label="职高(三)" :value="73"></el-option>
              <el-option label="大一" :value="91"></el-option>
              <el-option label="大二" :value="92"></el-option>
              <el-option label="大三" :value="93"></el-option>
              <el-option label="大四" :value="94"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="用户头像：" prop="name">
            <img src="/static/img/defalut_head.jpg" class="user-avatar" alt="" v-if="!form.userAvatarUrl" @click="toggleShow">
            <img :src="form.userAvatarUrl" class="user-avatar" alt="" v-if="form.userAvatarUrl" @click="toggleShow">
          </el-form-item>
          <!-- <el-form-item label="系统专业：">
            <span>{{ form.subjectCatalogueNames }}</span>
          </el-form-item> -->
        </el-form>
        <el-form class="mt-20" :model="form2" :rules="rules2" ref="userForm2" label-width="100px" v-show="modifyType == '2'">
          <el-form-item label="登录账号：">
            <span>{{ $root.userInfo.loginName }}</span>
          </el-form-item>
          <el-form-item label="原密码：" prop="oldPwd">
            <el-input v-model="form2.oldPwd" placeholder="输入原密码" type="password"></el-input>
          </el-form-item>
          <el-form-item label="新密码：" prop="newPwd">
            <el-input v-model="form2.newPwd" placeholder="输入新密码" type="password"></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="checkPwd">
            <el-input v-model="form2.checkPwd" placeholder="再次输入新密码" type="password"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="modifyInfo('hide')" :loading="loading">确定</el-button>
      </div>
    </el-dialog>
    <my-upload :modelValue.sync="show" v-if="show" size="2.1" :url="action" img-format="png" :headers="headers" @crop-upload-success="cropUploadSuccess"></my-upload>
  </div>
</template>

<script>
import MyUpload from 'vue-image-crop-upload';
import QrCode from "@/components/QrCode"
export default {
  components: {
    MyUpload,
    QrCode,
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form2.newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      activeIndex: '',
      parentActiveIndex: "",
      userInfo: {},
      menus: [],
      timer: null,
      loading: false,
      dialogVisible: false,
      form: {},
      form2: {
        oldPwd: "",
        newPwd: "",
        checkPwd: "",
      },
      rules: {
        realName: [
          { required: true, message: '请输入用户姓名', trigger: "change" },
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: "change" },
        ],
      },
      rules2: {
        oldPwd: [
          { required: true, message: '请输入原密码', trigger: "change" },
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: "change" },
          { pattern: /^(?=.*\D)[\da-zA-Z!@#$%^&*()_+-=]{6,18}$/, message: '密码格式为6~18位非纯数字组合' },
        ],
        checkPwd: [
          { required: true, validator: validatePass2, trigger: 'change' },
        ],
      },
      show: false,
      action: this.envConfig.file + "/api/OSS/PutLocalFile",
      modifyType: "1",
      headers: {
        Authorization: this.func.getToken(),
      },
      msItem: null,
      nationList: [],
    }
  },
  created() {
    this.nationList = this.func.getNationList();
  },
  mounted() {
    this.userInfo = this.$root.userInfo;
    if (this.userInfo.token) {
      this.getMenu();
    }
    this.$bus.$on("Update_UserInfo", data => {
      this.userInfo = this.$root.userInfo;
      if (this.menus.length == 0) {
        this.getMenu();
      }
      this.$forceUpdate();
    });
    this.$bus.$on("Update_TenantInfo", data => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    if (!this.$root.userInfo.token) {
      return
    }
    this.$bus.$off('Update_UserInfo');
    this.$bus.$off('Update_TenantInfo');
  },
  watch: {
    $route(to) {
      this.activeIndex = to.path;
      this.parentActiveIndex = this.activeIndex.split("/")[1];
    },
    show() {
      this.headers.Authorization = this.func.getToken();
    }
  },
  methods: {
    handleSelect(val, toPath = true) {
      if (val == "/ms") {
        let url = '/ms' + location.search;
        if (this.$root.userInfo.msHome) {
          url += "#" + this.$root.userInfo.msHome;
        }
        location.href = url;
      } else {
        const menus = this.menus.find(item => item.path == val);
        this.$bus.$emit("Update_Sliders", menus, toPath);
        this.$router.push({ path: val });
      }
    },
    logOut() {
      this.$confirm('即将注销登录退出到登录页面, 是否继续?', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.websocket.invoke("SendMessageToGroupAsync", this.$root.userInfo.tenantCode, { state: 0 });
        this.$root.userInfo = {};
        this.func.removeSession('userInfo');
        this.func.removeCookie('userInfo');
        this.func.removeSession("activeIndex");
        // this.func.removeSession("tenantInfo");
        // this.$root.tenantInfo = {
        //   code: "1",
        // };
        // this.func.setSession("tenantCode", "1");
        location.href = "/" + location.search;
      })
    },
    getMenu() {
      if (this.$root.tenantInfo.code == 'auth') {
        this.menus = [{
          "id": "1",
          "parentId": "0",
          "name": "项目评审",
          "path": "/review/index",
          "children": [],
        }];
        return;
      }
      let params = {
        parentId: 0,
        permissionPlatform: "pc",
        tenantCode: this.$root.tenantInfo.code,
      }
      this.https("get", "/api/Permission/GetNavigationBar", params).then(res => {
        this.menus = res.response ? res.response.children || [] : [];
        let index = this.menus.findIndex(item => item.path == "/ms");
        if (index >= 0) {
          this.msItem = this.menus[index];
          this.menus.splice(index, 1);
        }
        if (this.menus.length > 0) {
          if (this.menus[0].children && this.menus[0].children.length > 0) {
            this.$root.userInfo.pcHome = this.menus[0].children[0].path;
          } else {
            this.$root.userInfo.pcHome = this.menus[0].path;
          }
        } else {
          this.$router.push({ path: "/other/authorization" });
        }
        // this.handleSelect(this.$route.matched[0].path, false);
      })
    },
    handleModifyType(val) {
      if (this.modifyType == '1') {
        if (val == 'show') {
          this.form = this.func.depCopy(this.$root.userInfo);
          this.form.practiceTime = this.func.formatDate(this.form.practiceTime, "yyyy-MM-dd");
          this.form.graduateTime = this.func.formatDate(this.form.graduateTime, "yyyy-MM-dd");
        }
      } else if (this.modifyType == '2') {
        this.$refs["userForm2"].resetFields();
      }
    },
    modifyInfo(type) {
      if (type == 'show') {
        this.dialogVisible = true;
        this.modifyType = '1';
        this.handleModifyType('show');
      } else {
        if (this.modifyType == '1') {
          this.$refs["userForm"].validate((valid) => {
            if (valid) {
              let params = this.func.depCopy(this.form);
              params.practiceTime = this.func.formatDate(params.practiceTime, "yyyy-MM-dd");
              params.graduateTime = this.func.formatDate(params.graduateTime, "yyyy-MM-dd");
              this.loading = true;
              this.https("put", "/api/User/ChangeBasic", params).then(res => {
                this.loading = false;
                if (res.success) {
                  this.dialogVisible = false;
                  this.$root.getUserBaseInfo();
                } else {
                  this.func.message("error", res.msg);
                }
              }).catch(() => {
                this.loading = false;
              })
            } else {
              return false;
            }
          });
        } else if (this.modifyType == '2') {
          this.$refs["userForm2"].validate((valid) => {
            if (valid) {
              let params = this.func.depCopy(this.form2);
              this.loading = true;
              this.https("post", `/api/User/ChangePwd`, params).then(res => {
                this.loading = false;
                if (res.success) {
                  this.dialogVisible = false;
                  this.func.removeCookie("userInfo");
                  this.func.removeSession("userInfo");
                  this.func.message("success", "密码修改成功，请重新登录");
                  setTimeout(() => {
                    location.href = location.origin + "#/account/login?account=" + this.$root.userInfo.loginName + "&redirect=" + encodeURIComponent(location.href);
                  }, 200);
                } else {
                  this.func.message("error", res.msg);
                }
              }).catch(() => {
                this.loading = false;
              })
            } else {
              return false;
            }
          });
        }
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    cropUploadSuccess(res, field) {
      let file = res.response;
      this.form.userAvatarUrl = file.fileSource;
      this.form.userAvatar = file.files.id;
      this.$forceUpdate();
      this.show = false;
    },
    backHome() {
      this.$router.push({ path: this.$root.userInfo.pcHome });
    },
    wxDialogShow() {
      this.$root.wxDialogVisible = true;
    }
  },
}
</script>
<style>
.nav-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  height: 50px;
  background-color: #04adc0;
  box-shadow: 0px 0px 10px 2px #ccc;
  display: flex;
  overflow: hidden;
  align-items: center;
  padding: 0 1.2vw;
  justify-content: space-between;
  min-width: 1360px;
}

@media (max-width: 1366px) {
  .nav-header {
    width: 1366px;
  }
}

.nav-header .el-menu {
  background-color: transparent;
}

.nav-header .el-menu.el-menu--horizontal {
  box-sizing: border-box;
  display: flex;
  border: none;
  text-align: center;
  width: 100%;
  justify-content: center;
}

.nav-header .el-menu--horizontal > .el-menu-item {
  height: 50px;
  line-height: 50px;
  position: relative;
}

.nav-header .el-menu--horizontal > .el-menu-item .el-badge__content.is-fixed {
  top: 20px;
  right: 0px;
  padding: 0 5px;
  border: none;
  min-width: 18px;
}

.nav-header > div {
  display: flex;
  vertical-align: middle;
  align-items: center;
}

.nav-header .main-nav {
  height: 50px;
  flex: 1;
  position: absolute;
  left: 0;
  width: 100%;
  justify-content: center;
}

.nav-header .main-nav .el-menu-item {
  float: none;
  display: inline-block;
  vertical-align: middle;
  font-size: 15px;
  padding: 0;
  margin: 0px 15px;
  color: #fff;
  vertical-align: middle;
}

.nav-header .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus {
  background-color: transparent;
}

.nav-header .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 50px;
  line-height: 50px;
  color: #fff !important;
  font-size: 15px;
  padding: 0;
  margin: 0px 20px;
}

.nav-header .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background-color: transparent;
}

.nav-header .el-menu--horizontal > .el-submenu .el-submenu__title i {
  color: #fff;
}

.nav-header .el-menu--horizontal > .el-submenu.is-active .el-submenu__title,
.nav-header .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  border-bottom: 3px solid rgba(255, 255, 255, 0.8) !important;
  /* background-color: rgba(0, 0, 0, 0.1) !important; */
}

.nav-header .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  /* display: none; */
  margin-right: -10px;
  margin-left: 3px;
}

.nav-header .el-menu-item.is-active,
.nav-header .el-menu-item:hover {
  border-bottom: 3px solid rgba(255, 255, 255, 1) !important;
  background-color: rgba(0, 0, 0, 0) !important;
  color: #fff !important;
}

.nav-header .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.nav-header .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #fff;
}

.nav-header .nav-left {
  height: 50px;
  z-index: 2;
}

.nav-header .nav-left > a {
  cursor: pointer;
}

.nav-header .nav-left .logo {
  height: 26px;
  display: inline-block;
  vertical-align: middle;
}

.nav-header .nav-left .s-name {
  font-size: 17px;
  display: inline-block;
  vertical-align: middle;
  font-weight: 600;
  color: #fff;
  position: relative;
  margin-left: 5px;
  line-height: initial;
}

.nav-header .nav-right {
  text-align: right;
  /* display: inline-block;
  vertical-align: middle; */
}

.nav-header .nav-right .el-dropdown {
  color: #fff;
}

.nav-header .nav-right .el-dropdown-link {
  display: inline-block;
  cursor: pointer;
}

.nav-header .nav-right {
  color: #fff;
  z-index: 2;
}

.nav-header .nav-right .name {
  display: inline-block;
  vertical-align: top;
  text-overflow: ellipsis;
}

.nav-header .nav-right .link {
  color: #fff;
  padding: 8px 0 6px;
  font-size: 15px;
  border-bottom: 1px solid transparent;
}

.nav-header .nav-right .link:hover {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.8) !important;
}

.nav-header .v-line {
  height: 20px;
  width: 2px;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  background-color: rgba(0, 0, 0, 0.1);
  margin: 0 0.6vw;
  border-radius: 2px;
}

.nav-header .avatar {
  height: 26px;
  width: 26px;
  border-radius: 50%;
  vertical-align: middle;
}

.nav-header-box .user-avatar {
  height: 80px;
  width: auto;
  border: 1px solid #eee;
}

.nav-header .avatar:hover {
  cursor: pointer;
}

.nav-header-box .user-avatar:hover {
  opacity: 0.9;
}

.nav-header-box .el-tabs__item {
  font-size: 15px;
}

.nav-header-box .wx-icon {
  color: #fff;
  font-size: 20px;
}

.nav-header-box .wx-icon:hover {
  cursor: pointer;
  opacity: 0.8;
  transition: all 0.2s;
}

/* 
.el-menu--horizontal.sub-item {
  margin-left: 10px;
} */

.sub-item .el-menu--popup {
  min-width: auto;
  border-radius: 4px;
  padding: 0;
  margin-top: 0px;
}

.sub-item .el-menu--popup .el-menu-item {
  padding: 0 25px;
  font-size: 15px;
  color: #555;
  border-bottom: 1px solid #eee;
}

.sub-item .el-menu--popup .el-menu-item.is-active {
  color: #04adc0 !important;
  font-weight: bold;
  background-color: #e8f8f8 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/pc/components/shared/NavHeader.vue